var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWeightloss = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Diet-Scale--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Diet Scale Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.44 5.08a1.49 1.49 0 0 0 -0.55 -1.32A17.2 17.2 0 0 0 12 0 17.2 17.2 0 0 0 1.11 3.76a1.47 1.47 0 0 0 -0.55 1.32l1.85 17.58A1.5 1.5 0 0 0 3.9 24h16.2a1.5 1.5 0 0 0 1.49 -1.34ZM20.5 8.5a0.5 0.5 0 0 1 -0.5 0.5h-6.28a0.5 0.5 0 0 1 -0.47 -0.34l-0.78 -2.32a0.51 0.51 0 0 0 -0.94 0l-0.78 2.32a0.49 0.49 0 0 1 -0.47 0.34H4a0.5 0.5 0 0 1 -0.5 -0.5V5.37A0.5 0.5 0 0 1 3.73 5 14.22 14.22 0 0 1 5.8 3.83a0.47 0.47 0 0 1 0.4 0 0.46 0.46 0 0 1 0.27 0.29l0.74 2.08a0.75 0.75 0 0 0 0.71 0.5 0.73 0.73 0 0 0 0.25 0 0.76 0.76 0 0 0 0.46 -1l-0.78 -2.19a0.37 0.37 0 0 1 0 -0.31 0.39 0.39 0 0 1 0.27 -0.2 14.75 14.75 0 0 1 2.59 -0.44 0.48 0.48 0 0 1 0.38 0.13 0.51 0.51 0 0 1 0.16 0.37V4a0.75 0.75 0 0 0 1.5 0v-0.94a0.51 0.51 0 0 1 0.16 -0.37 0.48 0.48 0 0 1 0.38 -0.13 14.75 14.75 0 0 1 2.59 0.44 0.39 0.39 0 0 1 0.25 0.2 0.37 0.37 0 0 1 0 0.31l-0.76 2.19a0.76 0.76 0 0 0 0.46 1 0.73 0.73 0 0 0 0.25 0 0.75 0.75 0 0 0 0.71 -0.5l0.74 -2.08a0.46 0.46 0 0 1 0.27 -0.29 0.47 0.47 0 0 1 0.4 0A14.22 14.22 0 0 1 20.27 5a0.5 0.5 0 0 1 0.23 0.42Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWeightloss);
export default ForwardRef;